import {brandConfig, CONSTANTS} from '../../libs/ui/src';

const env = process.env.NX_PUBLIC_ENV || 'production';
let url = isProd() ? 'https://api.cuegrowth.ai/growth/' : 'https://api-dev.cuegrowth.ai/growth/';
let ws_url = isProd() ? 'wss://api.cuegrowth.ai/ws/' : 'wss://api-dev.cuegrowth.ai/ws/';
const tm_url = isProd() ? 'https://grid.cuegrowth.ai/core/' : 'https://grid-dev.cuegrowth.ai/core/';
const ml_url = isProd() ? 'https://ml-api.cuegrowth.ai/api/' : 'https://ml-api-dev.cuegrowth.ai/api/';
const wh_url = isProd() ? 'https://api.cuegrowth.ai/wh/' : 'https://api-dev.cuegrowth.ai/wh/';
const bot_grid_url = isProd() ? 'grid.cuegrowth.ai/bot/' : 'grid-dev.cuegrowth.ai/bot/';
const intercomAppId = isProd() && brandConfig.intercomFeature ? brandConfig.intercomAppId : 'tnke9fcd';

if (brandConfig.isInfinite) {
  url = isProd() ? 'https://api.infinite.co.il/growth/' : 'https://api-dev.cuegrowth.ai/growth/';
  ws_url = isProd() ? 'wss://api.infinite.co.il/ws/' : 'wss://api-dev.cuegrowth.ai/ws/';
} else if (brandConfig.isBreach) {
  url = isProd() ? 'https://api.breachdigital.com/growth/' : 'https://api-dev.cuegrowth.ai/growth/';
  ws_url = isProd() ? 'wss://api.breachdigital.com/ws/' : 'wss://api-dev.cuegrowth.ai/ws/';
} else if (brandConfig.isAlura) {
  url = isProd() ? 'https://api.alurapexus.no/growth/' : 'https://api-dev.cuegrowth.ai/growth/';
  ws_url = isProd() ? 'wss://api.alurapexus.no/ws/' : 'wss://api-dev.cuegrowth.ai/ws/';
}

export function isProd() {
  return env === 'production';
}

const _CONSTANTS = {
  ...CONSTANTS,
  env,
  url,
  ws_url,
  wh_url,
  tm_url,
  ml_url,
  bot_grid_url,
  intercomAppId,
};

export {_CONSTANTS as CONSTANTS};
